"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f121 = void 0;
exports.f121 = {
    "yaa": [
        "Latn"
    ],
    "yab": [
        "Latn"
    ],
    "yac": [
        "Latn"
    ],
    "yad": [
        "Latn"
    ],
    "yae": [
        "Latn"
    ],
    "yaf": [
        "Latn"
    ],
    "yag": [
        "Latn"
    ],
    "yah": [
        "Cyrl",
        "Latn"
    ],
    "yai": [
        "Cyrl"
    ],
    "yaj": [
        "Latn"
    ],
    "yak": [
        "Latn"
    ],
    "yal": [
        "Arab",
        "Latn"
    ],
    "yam": [
        "Latn"
    ],
    "yan": [
        "Latn"
    ],
    "yao": [
        "Latn",
        "Arab"
    ],
    "yap": [
        "Latn"
    ],
    "yaq": [
        "Latn"
    ],
    "yar": [
        "Latn"
    ],
    "yas": [
        "Latn"
    ],
    "yat": [
        "Latn"
    ],
    "yau": [
        "Latn"
    ],
    "yav": [
        "Latn"
    ],
    "yaw": [
        "Latn"
    ],
    "yax": [
        "Latn"
    ],
    "yay": [
        "Latn"
    ],
    "yaz": [
        "Latn"
    ],
    "yba": [
        "Latn"
    ],
    "ybb": [
        "Latn"
    ],
    "ybe": [
        "Latn",
        "Ougr"
    ],
    "ybh": [
        "Deva"
    ],
    "ybi": [
        "Deva"
    ],
    "ybj": [
        "Latn"
    ],
    "ybk": [
        "Zyyy"
    ],
    "ybl": [
        "Latn"
    ],
    "ybm": [
        "Latn"
    ],
    "ybn": [
        "Latn"
    ],
    "ybo": [
        "Latn"
    ],
    "ybx": [
        "Latn"
    ],
    "yby": [
        "Latn"
    ],
    "ych": [
        "Zyyy"
    ],
    "ycl": [
        "Latn"
    ],
    "ycn": [
        "Latn"
    ],
    "ycp": [
        "Zyyy"
    ],
    "yda": [
        "Latn"
    ],
    "yde": [
        "Latn"
    ],
    "ydg": [
        "Arab"
    ],
    "ydk": [
        "Latn"
    ],
    "yea": [
        "Knda",
        "Mlym"
    ],
    "yec": [
        "Latn"
    ],
    "yee": [
        "Latn"
    ],
    "yei": [
        "Latn"
    ],
    "yej": [
        "Grek"
    ],
    "yel": [
        "Latn"
    ],
    "yer": [
        "Latn"
    ],
    "yes": [
        "Latn"
    ],
    "yet": [
        "Latn"
    ],
    "yeu": [
        "Telu"
    ],
    "yev": [
        "Latn"
    ],
    "yey": [
        "Latn"
    ],
    "yga": [
        "Latn"
    ],
    "ygi": [
        "Latn"
    ],
    "ygl": [
        "Latn"
    ],
    "ygm": [
        "Latn"
    ],
    "ygp": [
        "Plrd"
    ],
    "ygr": [
        "Latn"
    ],
    "ygs": [
        "Zxxx"
    ],
    "ygu": [
        "Latn"
    ],
    "ygw": [
        "Latn"
    ],
    "yha": [
        "Zyyy"
    ],
    "yhd": [
        "Hebr"
    ],
    "yhl": [
        "Zyyy"
    ],
    "yhs": [
        "Zxxx"
    ],
    "yi": [
        "Hebr"
    ],
    "yia": [
        "Latn"
    ],
    "yif": [
        "Zyyy"
    ],
    "yig": [
        "Yiii"
    ],
    "yih": [
        "Hebr"
    ],
    "yii": [
        "Latn"
    ],
    "yij": [
        "Latn"
    ],
    "yik": [
        "Zyyy"
    ],
    "yil": [
        "Latn"
    ],
    "yim": [
        "Latn"
    ],
    "yin": [
        "Zyyy"
    ],
    "yip": [
        "Zyyy"
    ],
    "yiq": [
        "Zyyy"
    ],
    "yir": [
        "Latn"
    ],
    "yis": [
        "Latn"
    ],
    "yit": [
        "Zyyy"
    ],
    "yiu": [
        "Zyyy"
    ],
    "yiv": [
        "Zyyy"
    ],
    "yix": [
        "Zyyy"
    ],
    "yiz": [
        "Zyyy"
    ],
    "yka": [
        "Latn",
        "Arab"
    ],
    "ykg": [
        "Cyrl"
    ],
    "yki": [
        "Latn"
    ],
    "ykk": [
        "Latn"
    ],
    "ykl": [
        "Zyyy"
    ],
    "ykm": [
        "Latn"
    ],
    "ykn": [
        "Zyyy"
    ],
    "yko": [
        "Latn"
    ],
    "ykr": [
        "Latn"
    ],
    "ykt": [
        "Zyyy"
    ],
    "yku": [
        "Zyyy"
    ],
    "yky": [
        "Latn"
    ],
    "yla": [
        "Latn"
    ],
    "ylb": [
        "Latn"
    ],
    "yle": [
        "Latn"
    ],
    "ylg": [
        "Latn"
    ],
    "yli": [
        "Latn"
    ],
    "yll": [
        "Latn"
    ],
    "ylm": [
        "Zyyy"
    ],
    "yln": [
        "Zyyy"
    ],
    "ylo": [
        "Zyyy"
    ],
    "ylr": [
        "Latn"
    ],
    "ylu": [
        "Latn"
    ],
    "yly": [
        "Latn"
    ],
    "ymb": [
        "Latn"
    ],
    "ymc": [
        "Zyyy"
    ],
    "ymd": [
        "Zyyy"
    ],
    "yme": [
        "Latn"
    ],
    "ymg": [
        "Latn"
    ],
    "ymh": [
        "Zyyy"
    ],
    "ymi": [
        "Zyyy"
    ],
    "ymk": [
        "Latn",
        "Arab"
    ],
    "yml": [
        "Latn"
    ],
    "ymm": [
        "Latn"
    ],
    "ymn": [
        "Latn"
    ],
    "ymo": [
        "Latn"
    ],
    "ymp": [
        "Latn"
    ],
    "ymq": [
        "Zyyy"
    ],
    "ymr": [
        "Zyyy"
    ],
    "yms": [
        "Zyyy"
    ],
    "ymx": [
        "Zyyy"
    ],
    "ymz": [
        "Zyyy"
    ],
    "yna": [
        "Plrd"
    ],
    "ynd": [
        "Latn"
    ],
    "yne": [
        "Zyyy"
    ],
    "yng": [
        "Latn"
    ],
    "ynk": [
        "Cyrl"
    ],
    "ynl": [
        "Latn"
    ],
    "ynn": [
        "Zyyy"
    ],
    "yno": [
        "Zyyy"
    ],
    "ynq": [
        "Latn"
    ],
    "yns": [
        "Latn"
    ],
    "ynu": [
        "Latn"
    ],
    "yo": [
        "Latn",
        "Arab",
        "Brai"
    ],
    "yob": [
        "Latn"
    ],
    "yog": [
        "Latn"
    ],
    "yoi": [
        "Jpan"
    ],
    "yok": [
        "Latn"
    ],
    "yol": [
        "Zyyy"
    ],
    "yom": [
        "Latn"
    ],
    "yon": [
        "Latn"
    ],
    "yot": [
        "Latn"
    ],
    "yox": [
        "Zyyy"
    ],
    "yoy": [
        "Thai"
    ],
    "ypa": [
        "Zyyy"
    ],
    "ypb": [
        "Zyyy"
    ],
    "ypg": [
        "Zyyy"
    ],
    "yph": [
        "Zyyy"
    ],
    "ypm": [
        "Zyyy"
    ],
    "ypn": [
        "Zyyy"
    ],
    "ypo": [
        "Zyyy"
    ],
    "ypp": [
        "Zyyy"
    ],
    "ypz": [
        "Zyyy"
    ],
    "yra": [
        "Latn"
    ],
    "yrb": [
        "Latn"
    ],
    "yre": [
        "Latn"
    ],
    "yrk": [
        "Cyrl"
    ],
    "yrl": [
        "Latn"
    ],
    "yrm": [
        "Latn"
    ],
    "yrn": [
        "Zyyy"
    ],
    "yro": [
        "Latn"
    ],
    "yrs": [
        "Latn"
    ],
    "yrw": [
        "Latn"
    ],
    "yry": [
        "Latn"
    ],
    "ysc": [
        "Zyyy"
    ],
    "ysd": [
        "Yiii"
    ],
    "ysg": [
        "Zyyy"
    ],
    "ysl": [
        "Zxxx"
    ],
    "ysm": [
        "Zxxx"
    ],
    "ysn": [
        "Yiii"
    ],
    "yso": [
        "Zyyy"
    ],
    "ysp": [
        "Zyyy"
    ],
    "ysr": [
        "Cyrl"
    ],
    "yss": [
        "Latn"
    ],
    "ysy": [
        "Plrd"
    ],
    "yta": [
        "Zyyy"
    ],
    "ytl": [
        "Zyyy"
    ],
    "ytp": [
        "Zyyy"
    ],
    "ytw": [
        "Latn"
    ],
    "yty": [
        "Latn"
    ],
    "yua": [
        "Latn"
    ],
    "yub": [
        "Latn"
    ],
    "yuc": [
        "Latn"
    ],
    "yud": [
        "Hebr"
    ],
    "yue": [
        "Hant",
        "Brai",
        "Hans",
        "Latn"
    ],
    "yuf": [
        "Latn"
    ],
    "yug": [
        "Cyrl"
    ],
    "yui": [
        "Latn"
    ],
    "yuj": [
        "Latn"
    ],
    "yuk": [
        "Zyyy"
    ],
    "yul": [
        "Latn"
    ],
    "yum": [
        "Latn"
    ],
    "yun": [
        "Latn"
    ],
    "yup": [
        "Latn"
    ],
    "yuq": [
        "Latn"
    ],
    "yur": [
        "Latn"
    ],
    "yut": [
        "Latn"
    ],
    "yuw": [
        "Latn"
    ],
    "yux": [
        "Cyrl"
    ],
    "yuy": [
        "Zyyy"
    ],
    "yuz": [
        "Latn"
    ],
    "yva": [
        "Latn"
    ],
    "yvt": [
        "Latn"
    ],
    "ywa": [
        "Latn"
    ],
    "ywg": [
        "Latn"
    ],
    "ywl": [
        "Zyyy"
    ],
    "ywn": [
        "Latn"
    ],
    "ywq": [
        "Plrd",
        "Yiii"
    ],
    "ywr": [
        "Latn"
    ],
    "ywt": [
        "Zyyy"
    ],
    "ywu": [
        "Zyyy"
    ],
    "yww": [
        "Latn"
    ],
    "yxa": [
        "Latn"
    ],
    "yxg": [
        "Latn"
    ],
    "yxl": [
        "Latn"
    ],
    "yxm": [
        "Latn"
    ],
    "yxu": [
        "Latn"
    ],
    "yxy": [
        "Latn"
    ],
    "yyr": [
        "Latn"
    ],
    "yyu": [
        "Latn"
    ],
    "yyz": [
        "Zyyy"
    ],
    "yzg": [
        "Zyyy"
    ],
    "yzk": [
        "Zyyy"
    ]
};
